/**
 * @license @tabler/icons-vue v3.34.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconReceiptEuroFilled = createVueComponent("filled", "receipt-euro-filled", "IconReceiptEuroFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v16a1 1 0 0 1 -1.555 .832l-2.318 -1.545l-1.42 1.42a1 1 0 0 1 -1.32 .083l-.094 -.083l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083l-1.421 -1.42l-2.317 1.545a1 1 0 0 1 -1.55 -.72l-.005 -.112v-16a3 3 0 0 1 3 -3zm-3.875 4c-2.046 0 -3.668 1.746 -4.043 4h-.082a1 1 0 0 0 0 2h.082c.376 2.254 1.997 4 4.043 4c1.106 0 2.053 -.465 2.707 -1.445a1 1 0 1 0 -1.664 -1.11c-.267 .401 -.58 .555 -1.043 .555c-.882 0 -1.7 -.814 -2.002 -1.999l1.877 -.001a1 1 0 0 0 0 -2h-1.877c.301 -1.186 1.12 -2 2.002 -2c.462 0 .776 .154 1.043 .555a1 1 0 0 0 1.664 -1.11c-.654 -.98 -1.6 -1.445 -2.707 -1.445", "key": "svg-0" }]]);

export { IconReceiptEuroFilled as default };
//# sourceMappingURL=IconReceiptEuroFilled.mjs.map
